<div
	*ngIf="!mock"
	class="tile-wrapper"
	[style.height]="profileImage ? (isMiniCard ? '150px' : '173px') : '86.5px'"
	[style.justify-content]="forStaff ? 'unset' : 'center'"
	[style.background]="backgroundGradient()"
	[style.box-shadow]="boxShadow"
	[@pressState]="buttonState"
	(mouseenter)="hovered = true"
	(mouseleave)="buttonDown = false; hovered = false"
	appCrossPointerEventTarget
	(pointerClickEvent)="buttonDown = false; onClick($event)"
	(pointerDownEvent)="buttonDown = true"
	(pointerCancelEvent)="buttonDown = false">
	<div class="tile-title-container">
		<div [ngClass]="{ miniCard: isMiniCard }">
			<div class="ds-flex-center-center ds-w-100 ds-border-box ds-px-10 ds-mt-5" [style.margin-top]="!forStaff ? '10px' : '5px'">
				<div class="tile-content" #title [style.height]="forStaff ? '30px' : '20px'">
					<div
						*ngIf="pass.destination.title.length >= 10; else shortTitle"
						class="tile-title tile-title-truncated"
						[style.margin-top]="forStaff ? '8px' : '0px'"
						(mouseover)="onHover($event, title)"
						(mouseleave)="onLeave($event)">
						{{ pass.destination.title }}
					</div>
					<ng-template #shortTitle>
						<div class="tile-title" [style.margin-top]="forStaff ? '8px' : '0px'">{{ pass.destination.title }}</div>
					</ng-template>
				</div>
			</div>
			<div [attr.notranslate]="!presentational ? true : null" class="tile-subtitle">{{ presentational ? 'Linked Pass' : tileContent }}</div>
		</div>
		<div *ngIf="isBadgeVisible" class="badge">1</div>
	</div>

	<div class="profile-image animate" *ngIf="profileImage" [style.top]="isMiniCard ? '47px' : '54px'">
		<div
			*ngIf="pass.student?.profile_picture; else d"
			#avatar
			[ngStyle]="{ background: 'url(' + pass.student?.profile_picture + ') no-repeat left center/cover', width: '88px', height: '88px' }"></div>
		<ng-template #d>
			<img width="88" height="88" [src]="'./assets/Avatar Default.svg' | resolveAsset" alt="Avatar" />
		</ng-template>
	</div>

	<div class="tile-container-footer" *ngIf="!forStaff">
		<img
			[style.width]="'13px'"
			[style.height]="'15px'"
			*ngIf="pass.travel_type == 'one_way'"
			[src]="'./assets/SP Arrow (White).svg' | resolveAsset"
			class="tile-type" />
		<img
			[style.width]="'35px'"
			[style.height]="'15px'"
			*ngIf="pass.travel_type == 'round_trip'"
			[src]="'./assets/SP Arrow Double (White).svg' | resolveAsset"
			class="tile-type" />
		<!--    <div *ngIf="forStaff && !profileImage" class="names-overlay"></div>-->
	</div>
	<!--  <div *ngIf="forStaff" class="names">{{ tileName }}</div>-->
	<div class="overlay-shadow" *ngIf="showBackgroundOverlay && !isKioskMode" (mouseenter)="disableClose$.next()"></div>
	<div *ngIf="forStaff && !isKioskMode" class="names-overlay"></div>
	<div
		class="overlay"
		(mouseover)="showBackgroundOverlay = true; studentNameOver()"
		(mouseleave)="overlayLeave()"
		cdkOverlayOrigin
		#overlayTrigger="cdkOverlayOrigin">
		<div *ngIf="forStaff" notranslate class="names">{{ tileName }}</div>

		<ng-template
			cdkConnectedOverlay
			[cdkConnectedOverlayOrigin]="overlayTrigger"
			[cdkConnectedOverlayOpen]="isOpenTooltip | async"
			[cdkConnectedOverlayWidth]="335"
			[cdkConnectedOverlayHeight]="300"
			[cdkConnectedOverlayPositions]="overlayPositions"
			(positionChange)="updateOverlayPosition($event)"
			[cdkConnectedOverlayScrollStrategy]="scrollStrategy">
			<div
				class="student-passes"
				*ngIf="allowPopup && !isKioskMode"
				#studentPasses
				(mouseleave)="showBackgroundOverlay = false; setAnimationTrigger('fadeOut'); studentNameLeave()"
				(mouseover)="destroyAnimation$.next(); showBackgroundOverlay = true; disableClose$.next()">
				<app-student-passes
					[pass]="pass"
					[profile]="pass.student"
					[height]="300"
					[isResize]="false"
					(close)="isOpenTooltip.next(false)"
					(destroyClose)="destroyCloseQuickPreview = $event"></app-student-passes>
			</div>
		</ng-template>
	</div>
</div>
<!--{{boxShadow}}-->

<!-- Needs for Intro flow -->

<div
	*ngIf="mock"
	class="tile-wrapper"
	[style.background]="'radial-gradient(circle at 73% 71%,' + mock.gradient + ')'"
	[style.justify-content]="forStaff ? 'unset' : 'center'"
	[style.box-shadow]="boxShadow">
	<div class="tile-title tile-title-demo" [style.margin-top]="forStaff ? '13px' : '0px'">{{ mock.header }}</div>
	<div class="tile-subtitle">{{ mock.content }}</div>
	<ng-container *ngIf="!forStaff">
		<img
			[style.width]="'15px'"
			[style.height]="'15px'"
			*ngIf="mock.arrows === 'one'"
			[src]="'./assets/SP Arrow (White).svg' | resolveAsset"
			class="tile-round-trip" />
		<img
			[style.width]="'35px'"
			[style.height]="'15px'"
			*ngIf="mock.arrows === 'two'"
			[src]="'./assets/SP Arrow Double (White).svg' | resolveAsset"
			class="tile-one-way" />
	</ng-container>
	<div *ngIf="mock.badge" class="badge">1</div>
	<div *ngIf="forStaff" class="names-overlay"></div>
	<div *ngIf="forStaff" class="names">{{ mock.footer }}</div>
</div>

<!-- end -->
